import { EventEmitter } from "events";
import "whatwg-fetch";
import sessionStore from "./SessionStore";
import { checkStatus, errorHandler } from "./helpers";


class ApplicationStore extends EventEmitter {
  getAll (pageSize, offset, callbackFunc) {
    fetch("/api/applications?limit=" + pageSize + "&offset=" + offset, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if (typeof (responseData.result) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.result);
        }
      })
      .catch(errorHandler);
  }

  getAllSearchForOrganization (organizationID, pageSize, offset, match, callbackFunc) {
    fetch("/api/applications?organizationID=" + organizationID + "&limit=" + pageSize + "&offset=" + offset + "&match=" + match, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if (typeof (responseData.result) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.result);
        }
      })
      .catch(errorHandler);
  }

  getAllForOrganization (organizationID, pageSize, offset, match, callbackFunc) {
    fetch("/api/applications?organizationID=" + organizationID + "&limit=" + pageSize + "&offset=" + offset + "&match=" + match, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if (typeof (responseData.result) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.result);
        }
      })
      .catch(errorHandler);
  }

  getApplication (applicationID, callbackFunc) {
    fetch("/api/applications/" + applicationID, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  createApplication (application, callbackFunc) {
    fetch("/api/applications", { method: "POST", body: JSON.stringify(application), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  updateApplication (applicationID, application, callbackFunc) {
    fetch("/api/applications/" + applicationID, { method: "PUT", body: JSON.stringify(application), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  CopyApplication (data, callbackFunc) {
    fetch("/api/application/copy", {method: "POST", body: JSON.stringify(data), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  // 主要参考： http://blog.csdn.net/rickyit/article/details/70255627
  downloadApplication (applicationID, timeRange, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/download", { method: "POST", body: JSON.stringify(timeRange), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        fetch(responseData.filename)
          .then((res) => {
            var names = responseData.filename.split("/");
            var filename = names[names.length - 1];

            res.blob()
              .then(blob => {
                try {
                  var linkElement = document.createElement('a');
                  // var blob2 = blob.slice(0, blob.size, 'application/octet-stream');
                  var url = window.URL.createObjectURL(blob);
                  linkElement.setAttribute('href', url);
                  linkElement.setAttribute("download", filename);
                  var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                  });
                  linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                  console.log(ex);
                }
              })
              .then(callbackFunc());
          });
      })
      .catch(errorHandler);
  }

  //   downloadFile(filename, callbackFunc) {
  //     //fetch(filename, {responseType: "arraybuffer"})
  //     //.then((result) => {
  //       var linkElement = document.createElement('a');
  //       try {
  //         var blob = new Blob([result.data], { type: 'application/octet-stream' });
  //         var url = window.URL.createObjectURL(blob);
  //         linkElement.setAttribute('href', url);
  //         linkElement.setAttribute("download", 'filename.xlsx');
  //         var clickEvent = new MouseEvent("click", {
  //             "view": window,
  //             "bubbles": true,
  //             "cancelable": false
  //         });
  //         linkElement.dispatchEvent(clickEvent);
  //       } catch (ex) {
  //           console.log(ex);
  //       }
  // //})
  // //.catch(errorHandler);
  //   }

  deleteApplication (applicationID, callbackFunc) {
    fetch("/api/applications/" + applicationID, { method: "DELETE", headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  getUsers (applicationID, pageSize, offset, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/users?limit=" + pageSize + "&offset=" + offset, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if (typeof (responseData.result) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.result);
        }
      })
      .catch(errorHandler);
  }

  addUser (applicationID, user, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/users", { method: "POST", body: JSON.stringify(user), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  getUser (applicationID, userID, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/users/" + userID, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  removeUser (applicationID, userID, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/users/" + userID, { method: "DELETE", headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        this.emit("change");
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  updateUser (applicationID, userID, user, callbackFunc) {
    fetch("/api/applications/" + applicationID + "/users/" + userID, { method: "PUT", body: JSON.stringify(user), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        this.emit("change");
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  getOTA (applicationID, callbackFunc) {
    fetch("/api/ota/" + applicationID, { headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        this.emit("change");
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  updateOTA (applicationID, applicationOTAData, callbackFunc) {
    fetch("/api/ota/" + applicationID, { method: "PUT", body: JSON.stringify(applicationOTAData), headers: sessionStore.getHeader() })
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        this.emit("change");
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }
}

const applicationStore = new ApplicationStore();

export default applicationStore;



// WEBPACK FOOTER //
// ./src/stores/ApplicationStore.js